import React from 'react';
import { Sparkles, List } from 'lucide-react';

interface OptimizationDialogProps {
  isOpen: boolean;
  onConfirm: (optimize: boolean) => void;
  onCancel: () => void;
}

const OptimizationDialog: React.FC<OptimizationDialogProps> = ({
  isOpen,
  onConfirm,
  onCancel
}) => {
  if (!isOpen) return null;

  return (
    <div 
      className="fixed inset-0 z-[10000] flex items-center justify-center bg-black bg-opacity-50 p-4"
      onClick={onCancel}
    >
      <div 
        className="bg-white rounded-xl shadow-2xl max-w-md w-full p-6 animate-fade-in"
        onClick={(e) => e.stopPropagation()}
      >
        <h3 className="text-lg md:text-xl font-bold text-gray-900 mb-3 flex items-center gap-2">
          <Sparkles className="w-5 h-5 md:w-6 md:h-6 text-orange-500" />
          Optimize Your Itinerary?
        </h3>
        
        <p className="text-sm md:text-base text-gray-700 mb-6 leading-relaxed">
          Would you like us to optimize the order of activities within each day for the best experience? 
          We'll arrange them based on ideal timing, duration, and meal placement.
        </p>

        <div className="space-y-3 mb-6">
          <button
            onClick={() => onConfirm(true)}
            className="w-full bg-gradient-to-r from-orange-500 to-orange-600 hover:from-orange-600 hover:to-orange-700 text-white font-semibold py-2.5 md:py-3 px-4 rounded-lg transition-all duration-200 flex items-center justify-center gap-2 text-sm md:text-base"
          >
            <Sparkles className="w-4 h-4 md:w-5 md:h-5" />
            Yes, optimize my itinerary
          </button>
          
          <button
            onClick={() => onConfirm(false)}
            className="w-full bg-gray-100 hover:bg-gray-200 text-gray-800 font-semibold py-2.5 md:py-3 px-4 rounded-lg transition-all duration-200 flex items-center justify-center gap-2 text-sm md:text-base"
          >
            <List className="w-4 h-4 md:w-5 md:h-5" />
            No, keep my order
          </button>
        </div>

        <button
          onClick={onCancel}
          className="w-full text-gray-500 hover:text-gray-700 text-xs md:text-sm font-medium"
        >
          Cancel
        </button>
      </div>
    </div>
  );
};

export default OptimizationDialog;

